import NextLink from 'next/link';

import Avatar from 'components/base/Avatar';
import Grid from 'components/base/Grid';

import { ApiUserLightFragment } from 'gql/api/api-fragments.generated';
import { buildUserProfilePath } from 'utils/artwork/artwork';
import { getUsernameOrTruncatedAddress, hasUsername } from 'utils/helpers';

import SearchResultElement from './search-result/SearchResultElement';
import SearchResultHeading from './search-result/SearchResultHeading';
import SearchResultSubheading from './search-result/SearchResultSubheading';

interface SearchHitUserProps {
  user: ApiUserLightFragment;
  onClick: (arg0: ApiUserLightFragment) => void;
}

export default function SearchHitUser(props: SearchHitUserProps) {
  const { user, onClick } = props;

  const usernameOrTruncatedAddress = getUsernameOrTruncatedAddress(user);
  const userHasUsername = hasUsername(user);

  return (
    <NextLink
      legacyBehavior
      href={buildUserProfilePath({ user })}
      prefetch={false}
      passHref
    >
      <SearchResultElement as="a" onClick={() => onClick(user)}>
        <Avatar
          imageUrl={user.profileImageUrl}
          css={{ marginRight: '$4' }}
          size={4}
        />
        <Grid css={{ alignItems: 'center', gap: '$1' }}>
          {user.name && <SearchResultHeading>{user.name}</SearchResultHeading>}
          <SearchResultSubheading isMono={!userHasUsername}>
            {usernameOrTruncatedAddress}
          </SearchResultSubheading>
        </Grid>
      </SearchResultElement>
    </NextLink>
  );
}
